module.exports = __webpack_public_path__ + "static/media/logo-vid-sit.566bd0d9.png";